import Rocket from '@/assets/icons/Rocket.svg';
import { Elements } from '@/components';
import { Banner } from '@/components/elements/Banner/Banner';
import MaintainAOR from '@/assets/icons/MaintainAORSmall.svg';
import Platform from '@/assets/icons/Platform.svg';
import Pricing from '@/assets/icons/Pricing.svg';
import { Link } from 'react-router-dom';
import Image from 'next/image';

export const TurnKey = () => {
    return (
        <section className="overflow-hidden bg-[#004785] px-5 pt-20 pb-20 md:px-10 lg:px-[79px]">
            <div className="mx-auto flex w-full max-w-[500px] flex-col items-center justify-between gap-8 lg:max-w-[1200px] lg:flex-row lg:items-center">
                <div className="flex w-full flex-col items-center justify-start gap-4 md:items-center lg:max-w-[400px] lg:items-start">
                    <Banner variant="gradient" icon={<Image src={Rocket} alt="Rocket" width={20} height={20} />}>
                        Revolutionizing ICHRA Technology
                    </Banner>
                    <Elements.Title
                        title="Turn-key White Labeled ICHRA"
                        type="h1"
                        className="text-center text-gray-50 md:text-center lg:text-left"
                    />
                    <Elements.Description
                        description="The first truly white-labeled ICHRA platform that puts your brand, your clients, and your success first."
                        type="medium"
                        className="max-w-[400px] text-center font-normal text-gray-50 md:max-w-[460px] lg:text-left"
                        highlightWords={['your brand', 'your clients', 'your success']}
                        highlightClassName="text-gray-50 font-bold"
                    />

                    <div className="flex items-center justify-center gap-4 lg:items-start lg:justify-start">
                        <Link to="/demo">
                            <Elements.Button size="lg" variant="primary">
                                <span className='text-base md:text-xl lg:text-xl'>Book a Demo</span>
                            </Elements.Button>
                        </Link>
                    </div>

                    <div className="flex w-full items-stretch justify-between gap-2 md:justify-center md:gap-4">
                        {[
                            { top: '100%', bottom: 'Comission Retention' },
                            { top: '$0', bottom: 'Setup Fees' },
                            { top: '24/7', bottom: 'Support' },
                        ].map((item) => (
                            <div
                                key={item.bottom}
                                className="relative flex min-w-0 flex-1 md:inline-flex md:w-auto md:flex-initial"
                                style={{ borderRadius: 8, alignSelf: 'stretch' }}
                            >
                                <div
                                    style={{
                                        position: 'absolute',
                                        inset: 0,
                                        padding: 2,
                                        borderRadius: 8,
                                        background:
                                            'linear-gradient(151.57deg, rgba(255, 255, 255, 0.53) 14.18%, rgba(255, 255, 255, 0.11) 82.44%)',
                                        WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                                        WebkitMaskComposite: 'xor',
                                        maskComposite: 'exclude',
                                        pointerEvents: 'none',
                                    }}
                                />
                                <div
                                    className="flex h-full w-full flex-col items-start justify-center px-2 py-3 text-start text-gray-50 md:justify-between md:px-4"
                                    style={{
                                        background: '#0077DF21',
                                        borderRadius: 8,
                                    }}
                                >
                                    <span className="text-start text-xl font-medium md:text-3xl md:whitespace-nowrap">
                                        {item.top}
                                    </span>
                                    <span className="text-start text-base font-normal md:mt-1 md:text-base md:whitespace-nowrap">
                                        {item.bottom}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div
                    className="relative flex w-full items-start justify-start lg:max-w-[650px]"
                    style={{ borderRadius: 20 }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            padding: 2,
                            borderRadius: 20,
                            background:
                                'linear-gradient(108deg, rgba(255,255,255,0.51) 1.5%, rgba(255,255,255,0.09) 100%)',
                            WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                            WebkitMaskComposite: 'xor',
                            maskComposite: 'exclude',
                            pointerEvents: 'none',
                        }}
                    />
                    <div
                        className="flex w-full flex-col items-start justify-start gap-4 p-8 bg-[#0077DF1F] rounded-[20px]"

                    >
                        <Elements.Title title="Built Different" type="h2" className="text-left text-gray-50" />
                        <Elements.Description
                            description="While others compete with you, we empower you"
                            type="medium"
                            className="text-left font-normal text-gray-50"
                        />
                        <div className="relative w-full" style={{ borderRadius: 12 }}>
                            <div
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    padding: 1,
                                    borderRadius: 12,
                                    background:
                                        'linear-gradient(151.57deg, rgba(255, 255, 255, 0.53) 14.18%, rgba(255, 255, 255, 0.11) 82.44%)',
                                    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                                    WebkitMaskComposite: 'xor',
                                    maskComposite: 'exclude',
                                    pointerEvents: 'none',
                                }}
                            />
                            <div className="flex w-full items-center justify-center rounded-xl p-3 md:items-start md:justify-start">
                                <div className="flex flex-col items-center justify-center gap-4 md:flex-row md:items-center">
                                    <div className="flex h-[100px] w-[134px] items-center justify-center">
                                        <Image src={MaintainAOR} alt="Maintain AOR" width={134} height={56} className="mt-6" />
                                    </div>

                                    <div className="flex flex-col items-center justify-start gap-2 md:items-start">
                                        <p className="max-w-[260px] text-center text-lg font-medium text-gray-50 md:max-w-none md:text-left">
                                            Maintain AOR/BOR
                                        </p>
                                        <Elements.Description
                                            description="Own and retain your client base"
                                            type="small"
                                            className="max-w-[260px] text-center text-base font-normal text-[#FFFFFF99] md:max-w-none md:text-left"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="relative w-full" style={{ borderRadius: 12 }}>
                            <div
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    padding: 1,
                                    borderRadius: 12,
                                    background:
                                        'linear-gradient(151.57deg, rgba(255, 255, 255, 0.53) 14.18%, rgba(255, 255, 255, 0.11) 82.44%)',
                                    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                                    WebkitMaskComposite: 'xor',
                                    maskComposite: 'exclude',
                                    pointerEvents: 'none',
                                }}
                            />
                            <div className="flex w-full items-center justify-center rounded-xl p-3 md:items-start md:justify-start">
                                <div className="flex flex-col items-center justify-center gap-4 md:flex-row md:items-center">
                                    <div className="flex items-center justify-center">
                                        <Image src={Platform} alt="Platform" width={134} height={76} className="mt-2"/>
                                    </div>

                                    <div className="flex flex-col items-center justify-start gap-2 md:items-start">
                                        <p className="max-w-[260px] text-center text-lg font-medium text-gray-50 md:max-w-none md:text-left">
                                            Your own platform, brand and story
                                        </p>
                                        <Elements.Description
                                            description="Promote your brand, not someone else's"
                                            type="small"
                                            className="max-w-[260px] text-center text-base font-normal text-[#FFFFFF99] md:max-w-none md:text-left"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="relative w-full" style={{ borderRadius: 12 }}>
                            <div
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    padding: 1,
                                    borderRadius: 12,
                                    background:
                                        'linear-gradient(151.57deg, rgba(255, 255, 255, 0.53) 14.18%, rgba(255, 255, 255, 0.11) 82.44%)',
                                    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                                    WebkitMaskComposite: 'xor',
                                    maskComposite: 'exclude',
                                    pointerEvents: 'none',
                                }}
                            />
                            <div className="flex w-full items-center justify-center rounded-xl p-3 md:items-start md:justify-start">
                                <div className="flex flex-col items-center justify-center gap-4 md:flex-row md:items-center">
                                    <div className="flex items-center justify-center">
                                        <Image src={Pricing} alt="Pricing" width={144} height={76}/>
                                    </div>

                                    <div className="flex flex-col items-center justify-start gap-1 md:items-start">
                                        <p className="max-w-[260px] text-center text-lg font-medium text-gray-50 md:max-w-none md:text-left">
                                            Set your own pricing for uncapped earning potential
                                        </p>
                                        <Elements.Description
                                            description="Most brokers target $25-50 PEPM"
                                            type="small"
                                            className="max-w-[260px] text-center text-base font-normal text-[#FFFFFF99] md:max-w-none md:text-left"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
